import { createSelector } from '@ngrx/store';
import { filter, find, last, memoize } from 'lodash';
import { selectState } from './email-conversation.selectors';
import { emailMessageEntityAdapter } from '../adapters/email-message.adapter';

const DRAFT_ID = 'draft';

const { selectEntities, selectAll } = emailMessageEntityAdapter.getSelectors();

const selectEmailMessagesSubState = createSelector(selectState, state => state.messages);
const selectMessageSubStateByConversationId = memoize((conversationId: string) => createSelector(
  selectEmailMessagesSubState,
  state => state[conversationId]
));

export const selectEmailMessageEntitiesByConversationId = memoize((conversationId: string) => createSelector(
  selectMessageSubStateByConversationId(conversationId),
  subState => subState ? selectEntities(subState) : {}
));

const selectEmailMessagesByConversationId = memoize((conversationId: string) => createSelector(
  selectMessageSubStateByConversationId(conversationId),
  subState => subState ? selectAll(subState) : []
));

export const selectLastEmailMessageByConversationId = memoize((conversationId: string) => createSelector(
  selectEmailMessagesByConversationId(conversationId),
  emailMessages => last(filter(emailMessages, email => email.id !== DRAFT_ID))
));

export const selectDraftEmailMessageByConversationId = memoize((conversationId: string) => createSelector(
  selectEmailMessagesByConversationId(conversationId),
  emailMessages => find(emailMessages, email => email.id === DRAFT_ID)
));
